import type { TournamentOfChampionsRound } from './types';

function roundHasClaimablePlayerPrize(round: TournamentOfChampionsRound): boolean {
  const p = round.playerPrize;
  if (!p) return false;
  return (
    (typeof p.gcCoin === 'number' && p.gcCoin > 0) ||
    (typeof p.scCoin === 'number' && p.scCoin > 0) ||
    (Array.isArray(p.bundleItems) && p.bundleItems.length > 0)
  );
}

export function isTocRoundPendingAcknowledgement(round: TournamentOfChampionsRound | undefined): boolean {
  if (!round?.isFinalized || round.roundAcknowledged === true) return false;
  return round.playerTournamentKey != null || round.playerPosition != null || roundHasClaimablePlayerPrize(round);
}

export function findPendingEndOfRoundRoundIndex(rounds: TournamentOfChampionsRound[] | undefined): number {
  if (!rounds?.length) return -1;
  for (let i = 0; i < rounds.length; i += 1) {
    if (isTocRoundPendingAcknowledgement(rounds[i])) return i;
  }
  return -1;
}
